<script>
  import Conexoes from "../../Classes/Conexoes";
  import Constantes from "../../Classes/Constantes";
  import { DadosLogin } from "../../Classes/Stores";
  import CaixaDeDialogo from "../../componentes_basicos/CaixaDeDialogo.svelte";
  import CidadeEstado from "../../componentes_basicos/CidadeEstado.svelte";
  import DropDownDb from "../../componentes_basicos/DropDownDB.svelte";
  import Loading from "../../componentes_basicos/Loading.svelte";
  import LoadingTela from "../../componentes_basicos/LoadingTela.svelte";

  import { onMount } from "svelte";
  import DataGridRel from "../../componentes_basicos/DataGridRel.svelte";
  export let params;
  let id_desafio = params;
  let conexao = new Conexoes();
  let isLoading = false;
  let carregando = false;
  let link_video = "";
  let box = "";
  let judge = "";
  let outro_box = "";
  let cidade_box = "";
  let nome_box = "";
  let cidade_outro_box = "";
  let showModal = false;
  let confirma = false;
  let nomeEstadoSelecionado = "";
  let nomeCidadeSelecionada = "";
  let regras;
  let desafio;
  let quesitos = [];
  let respostas = [];
  let mensagemResult = "";
  let url = "";
  let isValid = false;
  let message = "";
  let JaRespondeu = false;

  let nome_usuario;
  let estado;
  let email;
  let cidade;
  let perguntasRespostas = [];
  let semDesafio = false;
  let exibeInputOutroBox = false;
  let config_drop_down = {
    api: Constantes.api_consultar_padrao,
    nome_coluna_opcoes: "box",
    nome_coluna_saida: "id",
    filtravel: true,
    itens: "",
    parametros: {
      query_code: "consulta_generica_livre",
      tabela: "box_view",
    },
  };

  async function submeterResultado() {
    isLoading = true;
    const resultado = {
      id_usuario: $DadosLogin.id_usuario,
      link_video,
      estado: nomeEstadoSelecionado,
      cidade: nomeCidadeSelecionada,
      box: box,
      judge: judge,
      outro_box: outro_box,
      cidade_outro_box: cidade_outro_box,
      respostas: respostas.reduce((acc, curr, index) => {
        acc[index] = curr;
        return acc;
      }, {}),
    };

    const response = await conexao.conecta(
      Constantes.api_respostas_desafios,
      resultado,
    );
    if (response && response.success) {
      mensagemResult = Constantes.msg_inserido_sucesso;
    } else {
      mensagemResult = Constantes.msg_erro_conexao_bd;
    }
    isLoading = false;
  }

  async function BaixarRegras() {
    isLoading = true;
    let result = await conexao.conecta(Constantes.api_consultar_padrao, {
      query_code: Constantes.query_code_busca_desafio,
      id_desafio: id_desafio,
    });
    if (!result || result.length == 0) {
      semDesafio = true;
    }
    desafio = result[0].desafio;
    regras = result[0].regras;
    isLoading = false;
  }
  async function VerificaJaPreencheu() {
    isLoading = true;
    let result = await conexao.conecta(Constantes.api_consultar_padrao, {
      query_code: Constantes.query_code_busca_resposta_desafio,
      id_desafio: id_desafio,
      id_usuario: $DadosLogin.id_usuario,
    });
    if (result && result.length > 0) {
      JaRespondeu = true;
      nome_usuario = result[0].nome_usuario;
      email = result[0].email;
      estado = result[0].estado;
      cidade = result[0].cidade;
      link_video = result[0].link_video;
      nome_box = result[0].nome_box;
      cidade_box = result[0].cidade_box;
      judge = result[0].judge;

      perguntasRespostas = result;
    }

    isLoading = false;
  }
  async function BaixarQuesitos() {
    isLoading = true;
    let result = await conexao.conecta(Constantes.api_consultar_padrao, {
      query_code: Constantes.query_code_busca_desafio_quesitos,
      id_desafio: id_desafio,
    });

    quesitos = result;

    quesitos.forEach((element) => {
      respostas[element.id] = 0;
      console.log(respostas[element.id]);
    });

    isLoading = false;
  }

  onMount(() => {
    BaixarRegras();
    BaixarQuesitos();
    VerificaJaPreencheu();
  });
  async function RetornaDrops(e) {
    console.log(e.detail.objeto.box);
    if (e.detail.objeto.box == "Outro ()") {
      exibeInputOutroBox = true;
    } else {
      outro_box = "";
      cidade_outro_box = "";
      exibeInputOutroBox = false;
    }

    //console.log(e.detail.objeto);
  }
  async function validateURL() {
    carregando = true;
    if (url === "") {
      isValid = false;
      message = Constantes.msg_url_invalida;
      carregando = false;
      return;
    }

    const data = await conexao.conecta(Constantes.api_proxy, { url });
    isValid = data.valid;
    message = isValid ? "URL válida" : Constantes.msg_url_invalida;
    carregando = false;
  }

  let timeout;
  function handleInput(event) {
    url = event.target.value;
    carregando = true;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      validateURL();
    }, 1000); // 1000ms delay
  }
</script>

<main class="margem">
  {#if !semDesafio}
    {#if desafio}
      <div class="container">
        {@html desafio}
        <hr />
      </div>
    {/if}

    {#if !JaRespondeu}
      <div>
        <p>Para cadastrar os desafios é preciso ler as regras</p>
        <input type="checkbox" bind:checked={confirma} /> Confirma que leu
        <a href="#" on:click={() => (showModal = true)}>regras dos Desafios?</a>
      </div>

      {#if confirma}
        {#if !$DadosLogin.cidade}
          <CidadeEstado bind:nomeCidadeSelecionada bind:nomeEstadoSelecionado />
        {/if}
        {#if $DadosLogin.cidade || nomeCidadeSelecionada}
          <div class="input-container">
            <label style="flex: 1;">
              Link do Vídeo:
              <input
                type="text"
                bind:value={link_video}
                disabled={!confirma}
                on:input={handleInput}
                style="width: 100%;"
              />
            </label>
            <div style="display: flex; align-items: center;">
              <Loading {carregando} />
            </div>
          </div>
        {/if}

        {#if link_video && isValid}
          <div class="input-container">
            <label style="flex: 1;">
              Judge:
              <input
                type="text"
                bind:value={judge}
                disabled={!confirma}
                style="width: 100%;"
              />
            </label>
          </div>
          <label style="flex: 1;">
            Selecione o Box:
            <DropDownDb
              config={config_drop_down}
              on:retorno={(e) => RetornaDrops(e)}
              bind:saida={box}
              class="text-field"
            />
          </label>
          {#if exibeInputOutroBox}
            <div class="input-container">
              <label style="flex: 1;">
                Nome do box:
                <input
                  type="text"
                  bind:value={outro_box}
                  disabled={!confirma}
                  style="width: 100%;"
                />
              </label>
            </div>
            <div class="input-container">
              <label style="flex: 1;">
                cidade do box:
                <input
                  type="text"
                  bind:value={cidade_outro_box}
                  disabled={!confirma}
                  style="width: 100%;"
                />
              </label>
            </div>
          {/if}
          <div>
            {#if quesitos && judge && ((box != "" && !exibeInputOutroBox) || (exibeInputOutroBox && cidade_outro_box && outro_box))}
              {#each quesitos as quesito}
                <label>
                  {quesito.pergunta}
                  <input
                    type="number"
                    bind:value={respostas[quesito.id]}
                    min="0"
                    max={quesito.max_range}
                    step={quesito.salto}
                    disabled={confirma}
                  />
                  <input
                    type="range"
                    bind:value={respostas[quesito.id]}
                    min="0"
                    max={quesito.max_range}
                    step={quesito.salto}
                    disabled={!confirma}
                  />
                </label>
              {/each}
            {/if}
          </div>
          <div>
            {#if quesitos && judge && ((box != "" && !exibeInputOutroBox) || (exibeInputOutroBox && cidade_outro_box && outro_box))}
              <button on:click={submeterResultado} disabled={!confirma}
                >Submeter Resultado</button
              >
            {/if}
          </div>
        {:else if !isValid && link_video}
          <div class="error-message">{message}</div>
        {/if}
      {/if}
    {:else}
      <div class="bordered-div">
        <strong
          ><span style="font-size: 22px; color: blue;"
            >Desafio já respondido</span
          ><br /><br />
          <span style="font-size: 22px">Suas respostas:</span><br /></strong
        ><br />
        <div>
          <div>
            <!--
            <strong>Nome: </strong>{nome_usuario}<br />
            <strong>Email: </strong>{email}<br /> 
            -->
            <strong>Cidade/Estado: </strong>{cidade}/{estado}<br />
            <strong>Link do Vídeo: </strong>{link_video}<br />
            <strong>Box: </strong>
            {nome_box}/{cidade_box}<br />
            <strong>Judge: </strong>
            {judge}<br /><br />
          </div>
        </div>
        <div>
          {#each perguntasRespostas as resposta}
            <strong
              >{resposta.pergunta}:<span style="font-size: 22px; color: blue;"
                >{resposta.resposta}</span
              ></strong
            ><br />
          {/each}
        </div>
      </div>
      <h2>Resultados:</h2>
      <DataGridRel
        parametros={{
          query_code: "consulta_generica_livre_sem_coluna_deletado",
          tabela: "desafio1_view",
        }}
      />
    {/if}
  {:else}
    <h2>Desafio inválido</h2>
  {/if}
</main>
<LoadingTela {isLoading} />
{#if showModal}
  <CaixaDeDialogo
    message={regras}
    on:close={() => {
      showModal = false;
    }}
  />
{/if}
<CaixaDeDialogo
  message={mensagemResult}
  on:close={() => {
    mensagemResult = "";
    window.location.reload();
  }}
/>

<style>
  .bordered-div {
    max-width: 700px;
    margin: 10px;
    padding: 10px;
    border: 2px solid black;
    border-radius: 10px;
  }

  @media (min-width: 600px) {
    .bordered-div {
      margin: auto;
    }
  }
  main {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .centralizado {
    text-align: center;
  }

  label {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    color: #333;
  }

  .checkbox-label {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    color: #333;
  }

  input[type="checkbox"] {
    appearance: none;
    width: 18px;
    height: 18px;
    border: 2px solid #1976d2;
    border-radius: 4px;
    position: relative;
    cursor: pointer;
    outline: none;
    transition: all 0.3s;
  }

  input[type="checkbox"]:checked {
    background-color: #1976d2;
    border: 2px solid #1976d2;
  }

  input[type="checkbox"]:checked::before {
    content: "";
    position: absolute;
    top: 2px;
    left: 6px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  input[type="text"],
  input[type="number"],
  input[type="time"],
  select {
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    outline: none;
    transition:
      border-color 0.3s,
      box-shadow 0.3s;
  }

  input[type="text"]:focus,
  input[type="number"]:focus,
  input[type="time"]:focus,
  input[type="text"]:disabled,
  input[type="number"]:disabled,
  input[type="time"]:disabled,
  select {
    background-color: #f5f5f5;
    color: #aaa;
  }

  button {
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 4px;
    background-color: #1976d2;
    color: white;
    cursor: pointer;
    transition: background-color 0.3s;
  }

  button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  button:not(:disabled):hover {
    background-color: #115293;
  }

  .margem {
    margin-top: 70px;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 100px;
  }

  .input-container {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .error-message {
    color: red;
    font-size: 1rem;
    font-family: "Roboto", sans-serif;
  }
</style>
